module.exports = __webpack_public_path__ + "fa-solid-900.20b351a6af2d523589fd.eot";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-solid-900.eot
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-solid-900.eot
// module chunks = styles